import { Component, OnInit } from '@angular/core';

import { AdminService }   from '../services/admins/admin.service';
import { Auth }       from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { ProviderService } from '../services/providers/provider.service';

@Component({
  moduleId: module.id,
  selector: 'my-dashboard',
  templateUrl: 'dashboard.component.html',
  styleUrls: [ 'dashboard.component.css' ]
})

export class DashboardComponent implements OnInit {
  authorized:boolean=false
  hideDoc:boolean=false
  hidePat:boolean=false
  hideAdm:boolean=false

  providers:any[]

  constructor(private auth:Auth,private adminService:AdminService, protected providerService: ProviderService) {
    /*console.log("Dashboard 1");
    this.auth.handleAuthentication()
    console.log("handled, now check admin")*/
  }

ngOnInit(){
  this.checkAdmin()
  this.getProviders()
}
getProviders(){
  this.providerService.get().then((response)=>{
    this.providers = response
    this.providers.push({id:0,name:"All"})
  })
}

checkAdmin(){
  this.authorized = this.auth.isAdmin()
  if (!this.authorized && this.auth.shouldFetchAdmin()){
    this.adminService.getMe().then(user => {
      if (user.type==2){
        this.authorized=true
        this.auth.putAdmin(user);
      } else {
        this.auth.logout()
      }
    })
  }
}

  search1(){
    this.hideDoc=false;
    this.hidePat=true;
    this.hideAdm=true;
  }
  search2(){
    this.hidePat=true;
    this.hideAdm=false;
    this.hideDoc=true;
  }
  search3(){
    this.hideAdm=true;
    this.hideDoc=true;
    this.hidePat=false;
  }
  search4(){
    this.hideAdm=true;
    this.hideDoc=true;
    this.hidePat=true;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts